<template>
  <div id="videocourse" class="ptop9">
    <div class="course_box">
      <div class="course_video">
        <video
          ref="videoPlay"
          preload="auto"
          poster=""
          :src="video.videourl"
          autoplay="autoplay"
          controls="controls"
          id="videoinfo"
        >
        </video>
      </div>
      <div class="course_title">
        <h2>第{{video.class_number}}课{{video.course_number}}小节 {{video.title}}</h2>
        <div class="course_info">
          <div class="box_left">
            <span v-if="video.is_free==1">免费观看<i>(该视频可免费观看)</i></span>
            <span v-if="video.is_free==false">付费观看<i>(该视频付费观看)</i></span>
          </div>
          <div class="box_right">
            <span>播放量：{{video.view}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="fgt"></div>
    <div class="course_bg">
      <h2>视频列表</h2>
      <div class="course_lists">
        <ul>
          <li class="iconfont">
            <a>第一课</a>
            <ol>
              <li v-for="item in datalist" @click="play(item)" :id="item.id" v-if="item.class_number==1">
                <a>第{{item.course_number}}小节</a>
                <span v-if="item.is_free==1">(免费课程)</span>
                <span v-if="item.is_free==0">(收费课程)</span>
              </li>
            </ol>
          </li>
          <li class="iconfont">
            <a>第二课</a>
            <ol>
              <li v-for="item in datalist" @click="play(item)" :id="item.id" v-if="item.class_number==2">
                <a>第{{item.course_number}}小节</a>
                <span v-if="item.is_free==1">(免费课程)</span>
                <span v-if="item.is_free==0">(收费课程)</span>
              </li>
            </ol>
          </li>
          <li class="iconfont">
            <a>第三课</a>
            <ol>
              <li v-for="item in datalist" @click="play(item)" :id="item.id" v-if="item.class_number==3">
                <a>第{{item.course_number}}小节</a>
                <span v-if="item.is_free==1">(免费课程)</span>
                <span v-if="item.is_free==0">(收费课程)</span>
              </li>
            </ol>
          </li>
          <li class="iconfont">
            <a>第四课</a>
            <ol>
              <li v-for="item in datalist" @click="play(item)" :id="item.id" v-if="item.class_number==4">
                <a>第{{item.course_number}}小节</a>
                <span v-if="item.is_free==1">(免费课程)</span>
                <span v-if="item.is_free==0">(收费课程)</span>
              </li>
            </ol>
          </li>
          <li class="iconfont">
            <a>第五课</a>
            <ol>
              <li v-for="item in datalist" @click="play(item)" :id="item.id" v-if="item.class_number==5">
                <a>第{{item.course_number}}小节</a>
                <span v-if="item.is_free==1">(免费课程)</span>
                <span v-if="item.is_free==0">(收费课程)</span>
              </li>
            </ol>
          </li>
          <li class="iconfont">
            <a>第六课</a>
            <ol>
              <li v-for="item in datalist" @click="play(item)" :id="item.id" v-if="item.class_number==6">
                <a>第{{item.course_number}}小节</a>
                <span v-if="item.is_free==1">(免费课程)</span>
                <span v-if="item.is_free==0">(收费课程)</span>
              </li>
            </ol>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Videocourse',
  data () {
    return {
      datalist: [],
      video: {}
    }
  },

  methods: {
    loaddata () {
      // 加载课程列表
      var that = this
      that.$wx.showLoading()
      that.$app.pr('/api/Videocourse/lists', {
        'kemu': that.$app.getParam('kemu')
      }).then((res) => {
        that.$wx.hideLoading()
        if (res.success) {
          that.datalist = res.data.lists
          // 读取上一次观看的进度
          that.$app.pr('/api/appuser/get_user.html',{
            'appuid': that.$store.state.userInfo.unionid
          }).then((result) => {
            if (result.success) {
              if (that.$app.getParam('kemu') == 2)// 科目四
              {
                if (result.data.videocourse_id1 == 0) {
                  that.play(that.datalist[0])
                } else {
                  that.play(that.datalist[result.data.videocourse_id1 - 601])
                }
              } else {
                if (result.data.videocourse_id == 0) {
                  that.play(that.datalist[0])
                } else {
                  that.play(that.datalist[result.data.videocourse_id - 1])
                }
              }
            }
          })
        } else {
          that.$wx.showToast('数据加载失败')
        }
      }).catch((res) => {
        that.$wx.hideLoading()
        that.$wx.showToast('加载失败')
      })
    },
    play (item) {
      var that = this
      var res = this.$store.state.userInfo
      if ((res.user_level_id || item.is_free == 1||res.isreal==1)) { // 判断是否是会员或者免费题目
        this.video = item
        $('.course_lists li').removeClass('actives')
        $('#' + item.id).addClass('actives')
        $('#videoinfo').attr('src', item.videourl)[0].play()
        // 增加浏览数
        this.$app.pr('/api/Videocourse/isread', {
          'id': item.id,
          'kemu': this.$app.getParam('kemu')
        }).then((res) => {
        })
      } else {
        this.$wx.showModal({
          title: '提示',
          content: '无法提供视频课程服务，请开通会员！',
          callback: function (result) {
            if (result.index == 1) {
              that.$wx.navigateTo({
                url: '/vip?back=1'
              })
            }
          }
        })
      }
    },
    nextplay (item) {
      var that = this
      var res = this.$store.state.userInfo
      if ((res.user_level_id || item.is_free == 1||res.isreal==1)) { // 判断是否是会员或者免费题目
        this.video = item
        this.$nextTick(() => {
          this.$refs.videoPlay.load()
        })
        // 增加浏览数
        this.$app.pr('/api/Videocourse/isread', {
          id: item.id
        }).then((res) => {
        })
        $('.course_lists li').removeClass('actives')
        $('#' + item.id).addClass('actives')
      } else {
        this.$wx.showModal({
          title: '提示',
          content: '无法提供视频课程服务，请开通会员！',
          callback: function (result) {
            if (result.index == 1) {
              that.$wx.navigateTo({
                url: '/vip?back=1'
              })
            }
          }
        })
      }
    }
  },
  mounted () {
    var that = this
    // 下啦抽屉特效
    // var h = document.querySelector('#videocourse').offsetHeight
    // var h = document.documentElement.clientHeight
    //    var courseList = document.querySelector('.course_bg')
    //    courseList.style.height = Math.abs(h - courseList.offsetTop) + 'px'
    // 	console.log(h)
    // 	console.log(courseList.offsetTop)
    $('.course_lists ul li a').click(function () {
      $(this).next('ol').stop().slideToggle(500)
      $(this).parent('li').toggleClass('active')
      $(this).parent('li').siblings('li').children('ol').slideUp(500)
      $(this).parent('li').siblings('li').removeClass('active')
      $(this).parent('li').siblings('li').children('ol').find('li').removeClass('active')
    })
    $('.course_lists ul li ol li').click(function () {
      $(this).addClass('active').siblings('li').removeClass('active')
    })
    // 视频播放完，自动到下一节
    $('#videoinfo').on('ended', function () {
      if (that.$app.getParam('kemu') == 2)// 科目四
      {
        that.nextplay(that.datalist[that.video.id - 600])
      } else {
        if (that.video.id < 600) {
          that.nextplay(that.datalist[that.video.id])
        }
      }
    })
  },
  created () {
    this.loaddata()
  }
}
</script>

<style>
	  #videocourse {
	    height: 100vh;
	    overflow: hidden;
	    background-color: #fff;
	  }
	
	  .course_box {
	    background-color: #fff;
	  }
	
	  .fgt {
	    background-color: #f8f8f8;
	    width: 100%;
	    height: .24rem;
	  }
	
	  /*.course_video {*/
	  /*  max-height: 4.5rem;*/
	  /*}*/
	
	  .course_video video {
	    width: 100%;
	    display: block;
	  }
	
	  .course_title {
	    padding: .2rem;
	  }
	
	  .course_title h2 {
	    font-size: .3rem;
	    color: #333;
	    line-height: .42rem;
	  }
	
	  .course_info {
	    display: flex;
	    justify-content: space-between;
	    padding: .1rem 0;
	  }
	
	  .course_info .box_left span {
	    font-size: .26rem;
	    color: #2AAFFB;
	  }
	
	  .course_info .box_left span i {
	    display: inline-block;
	    color: #ccc;
	    margin-left: .2rem;
	  }
	
	  .course_info .box_right span {
	    font-size: .26rem;
	    color: #999;
	  }
	
	  .course_bg {
	    background-color: #fff;
	    /* padding: .2rem 0; */
	  }
	
	  .course_bg h2 {
	    font-size: .28rem;
	    line-height: .8rem;
	    border-bottom: 1px solid #eee;
	    padding-left: .35rem;
	    position: relative;
	  }
	
	  .course_bg h2::before {
	    content: "";
	    position: absolute;
	    top: 50%;
	    left: .2rem;
	    background-color: #2AAFFB;
	    width: 2px;
	    height: 40%;
	    transform: translateY(-50%);
	  }
	
	  .course_lists {
	    padding: .1rem 0;
	    /* padding-bottom: 1rem; */
	    overflow: auto;
	    height: 38vh;
	  }
	
	  .course_lists ul li {
	    padding-left: .2rem;
	  }
	
	  .course_lists ul li a {
	    font-size: .26rem;
	    color: #333;
	    display: block;
	    line-height: .88rem;
	    border-bottom: 1px solid #eee;
	    padding: 0 .1rem;
	    padding-right: .4rem;
	    position: relative;
	  }
	
	  .course_lists ul li a::before {
	    content: "\e63aa";
	    position: absolute;
	    top: 50%;
	    right: .3rem;
	    transform: translateY(-50%);
	    font-size: .3rem;
	    color: #ccc;
	    transition: all .4s ease-in-out;
	  }
	
	  .course_lists ul li.active a {
	    background-color: #eee;
	    border-color: #eee;
	    color: #2AAFFB;
	  }
	
	  .course_lists ul li.active a::before {
	    color: #2AAFFB;
	    transform: translateY(-50%) rotate(90deg);
	  }
	
	  .course_lists ul li.actives a {
	    background-color: #eee;
	    border-color: #eee;
	    color: #2AAFFB;
	  }
	
	  .course_lists ul li.actives a::before {
	    color: #2AAFFB;
	    transform: translateY(-50%) rotate(90deg);
	  }
	
	  .course_lists ul li ol {
	    width: 100%;
	    padding: .1rem .2rem;
	    box-sizing: border-box;
	    background-color: #f9f9f9;
	    padding-bottom: .3rem;
	    display: none;
	  }
	
	  .course_lists ul li ol li a::before {
	    content: "";
	  }
	
	  .course_lists ul li.active ol li a {
	    color: #666;
	  }
	
	  .course_lists ul li.actives ol li a {
	    color: #666;
	  }
	
	  .course_lists ul li ol li {
	    display: flex;
	    width: 100%;
	    border-bottom: 1px solid #eee;
	    align-items: center;
	    padding-left: .1rem;
	  }
	
	  .course_lists ul li ol li a {
	    font-size: .24rem;
	    color: #666;
	    padding: 0 .1rem;
	    padding-left: .1rem;
	    border-bottom: 0;
	    max-width: 4rem;
	    white-space: nowrap;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    background-color: transparent !important;
	  }
	
	  .course_lists ul li ol li span {
	    font-size: .24rem;
	    color: #aaa;
	    display: block;
	    margin-left: .3rem;
	  }
	
	  .course_lists ul li ol li.active a {
	    color: #2AAFFB;
	  }
	
	  .course_lists ul li ol li.active span {
	    color: #2AAFFB;
	  }
	
	  .course_lists ul li ol li.actives a {
	    color: #2AAFFB;
	  }
	
	  .course_lists ul li ol li.actives span {
	    color: #2AAFFB;
	  }
	
</style>



// WEBPACK FOOTER //
// src/components/Videocourse.vue